import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-servicios-estudiantiles',
  templateUrl: './servicios-estudiantiles.component.html',
  styleUrls: ['./servicios-estudiantiles.component.scss'],
  providers: [DatePipe]
})

export class ServiciosEstudiantilesComponent implements OnInit {

  tituloPantalla = "SERVICIOS ESTUDIANTILES";

  @Input() cintillo = "";
  @Input() ahora: Date = null;

  constructor(private datePipe: DatePipe) { }

  ngOnInit(): void {
  }

}
